module.exports = "/consumer-goods.jpg?12ebcc";